<template>
  <div
    class="tw-p-2 tw-border tw-col-span-2 tw-border-primary tw-border-solid tw-rounded-xl"
  >
    <div
      class="tw-p-2 tw-border tw-border-solid tw-rounded-xl tw-mb-2 last:tw-mb-0"
      v-for="(item, index) in statistics"
      :key="index"
    >
      <div class="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 tw-gap-2 tw-mt-3">
        <ValidationProvider
          v-slot="{ errors }"
          :name="$t('labels.nubmer')"
          rules="required"
          class="tw-col-span-2"
        >
          <div class="input_wrapper">
            <label for="nubmer">{{ $t("labels.nubmer") }}</label>

            <app-input
              @input="updateValue"
              v-model="item.desc"
              id="nubmer"
              type="text"
              :placeholder="$t('labels.nubmer')"
              :name="$t('labels.nubmer')"
            ></app-input>
          </div>
          <span v-if="errors[0]" class="error--text d-inline-block">
            {{ errors[0] }}
          </span>
        </ValidationProvider>
        <ValidationProvider
          v-slot="{ errors }"
          :name="$t('labels.title') + $t('inArabic')"
          rules="required"
        >
          <div class="input_wrapper">
            <label for="title_ar">{{
              $t("labels.title") + $t("inArabic")
            }}</label>

            <app-input
              @input="updateValue"
              v-model="item.title_ar"
              id="title_ar"
              type="text"
              :placeholder="$t('labels.title') + $t('inArabic')"
              :name="$t('labels.title') + $t('inArabic')"
            ></app-input>
          </div>
          <span v-if="errors[0]" class="error--text d-inline-block">
            {{ errors[0] }}
          </span>
        </ValidationProvider>
        <ValidationProvider
          v-slot="{ errors }"
          :name="$t('labels.title') + $t('inEnglish')"
          rules="required"
        >
          <div class="input_wrapper">
            <label for="title_en">{{
              $t("labels.title") + $t("inEnglish")
            }}</label>

            <app-input
              @input="updateValue"
              id="title_en"
              v-model="item.title_en"
              type="text"
              :placeholder="$t('labels.title') + $t('inEnglish')"
              :name="$t('labels.title') + $t('inEnglish')"
            ></app-input>
          </div>
          <span v-if="errors[0]" class="error--text d-inline-block">
            {{ errors[0] }}
          </span>
        </ValidationProvider>
      </div>
      <div class="tw-flex tw-items-center tw-gap-2 tw-justify-end pt-2">
        <button
          class="base-btn tw-py-1 tw-px-2"
          type="button"
          @click="addSections(index)"
        >
          <i class="fas fa-plus"> </i>
        </button>
        <button
          class="base-btn-white tw-py-1 tw-px-2"
          type="button"
          v-if="statistics.length > 1"
          @click="deleteSection(index)"
        >
          <i class="fas fa-minus"> </i>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      required: true,
    },
  },
  data() {
    return {
      statistics: [
        {
          title_ar: "",
          title_en: "",
          desc: "",
        },
      ],

      btnLoading: false,
    };
  },

  methods: {
    addSections(i) {
      const item = {
        title_ar: "",
        title_en: "",
        desc: "",
      };

      this.statistics.splice(i + 1, 0, item);
    },
    deleteSection(i) {
      this.statistics.splice(i, 1);
    },
    updateValue() {
      this.$emit("input", this.statistics);
    },
  },
};
</script>

<style></style>
